var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5832 48.0003V47.3337C61.5832 42.3053 61.5832 39.7912 60.0212 38.2291C58.459 36.667 55.9449 36.667 50.9165 36.667H49.5833C44.5551 36.667 42.0409 36.667 40.4788 38.2291C38.9167 39.7912 38.9167 42.3053 38.9167 47.3336L38.9166 53.3337C38.9166 57.7169 38.9166 59.9086 40.1271 61.3837C40.3488 61.6538 40.5964 61.9014 40.8665 62.1231C42.3417 63.3337 44.5333 63.3337 48.9165 63.3337",
    stroke: "#152C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.25 43.333H56.25",
    stroke: "#152C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.25 50H52.25",
    stroke: "#152C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5834 60.667V56.667C61.5834 54.7611 59.7926 52.667 57.5834 52.667C55.3742 52.667 53.5834 54.7611 53.5834 56.667V61.3337C53.5834 62.4382 54.4788 63.3337 55.5834 63.3337C56.6879 63.3337 57.5834 62.4382 57.5834 61.3337V56.667",
    stroke: "#152C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuery);
export default __webpack_public_path__ + "static/media/Query.fa77df5746dfad719952f4a971651bea.svg";
export { ForwardRef as ReactComponent };